(function() {

  var linkFunction = function($scope, element, attrs) {
    $scope.editable = attrs.editable === 'false' ? false : true;
  };

  var controllerFunction = function($scope, $state, UserSession) {
    // console.log("Payment Summary Controller Func: ", $scope);
    $scope.wcmContent = wcmContent;
    $scope.addNew = localStorage.getItem('transactionMode') === 'ADD';
    $scope.continue=function(){
      createChannelUrl('recurringPayment');
    };
    /**
     * Vinoth 02/10/2017 - Feb 2017 Regression defect fix
     * Added logic to take member to payments module in mobile App
     * */
    $scope.editMop = function(mop) {
      //localStorage.clear();
      if(cvsUtility.setNativeCheck()){
          native.gotoPage('Payment');
        return;
      }
      var componentName=cvsUtility.componentName();
      if(componentName && (componentName=="RFR" || componentName=="myAccount" )){
        window.top.location=createChannelUrl('editAutoPayAD');
      }else{
        if(mop && mop.transactionMode && mop.transactionMode=="ADD"){
          /**/
          if(_.isEmpty(UserSession.persistCopy)){
            var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info";
            $state.go(dest, { 'mopid': mop.paymentMethodId});
          }else{
            Object.keys(UserSession.persit).forEach(function(key) { delete UserSession.persit[key]; });
            Object.keys(UserSession.persistCopy).forEach(function(key) {  UserSession.persit[key]=UserSession.persistCopy[key]; });
            localStorage.clear();
            localStorage.setItem("transactionMode", "ADD");
            var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info";
            //$state.go(dest, { 'mopid': mop.paymentMethodId, 'editMode': false });
            $state.go(dest, { 'mopid': mop.paymentMethodId  ,'editMode': true });
          }

        }else{
          $state.go("payment-methods");//, {'paymenttype': 'auto'}
        }

      }

    };

    $scope.goToPaymentMethod=function(){
      var componentName=cvsUtility.componentName();
      if(componentName && (componentName=="RFR" || componentName=="myAccount" )){
        window.top.location=createChannelUrl('editAutoPayAF');
      }else{
        $state.go("payment-methods", {'paymenttype': 'auto'});
      }

    };
    /**
     * Vinoth 02/10/2017 - Feb 2017 Regression defect fix
     * Added logic to take member to payments module in mobile App
     * */
    $scope.editAutoPayment=function(){
      localStorage.setItem("autoPayMode", "ADDED");
      var componentName=cvsUtility.componentName();

      /**
       * viswa 02/10/2020 - Jul 2020 Regression defect fix
       */
      // if(cvsUtility.setNativeCheck()){
      //   native.gotoPage('Payment');
      //   return;
      // }
      if(componentName && (componentName=="RFR" || componentName=="myAccount" )){
        window.top.location=createChannelUrl('editAutoPayAF');
      }else{
          $state.go("automatic-payments");
      }
    }


  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/autopaySummary/autopaySummary.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "$state", "userSession"];
  angular.module('cvsApp').directive('autopaySummary', directiveFunction);


})();
